import { Component, OnDestroy, OnInit, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { ReactiveFormsModule } from '@angular/forms';
import { LocationDataForm } from './forms/location-data.form';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { ActivatedRoute, Router } from '@angular/router';
import { updateParcels } from '../../../../../../store/actions/application.actions';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { ParcelsCrudComponent } from '../../../common/components/parcels/parcels-crud/parcels-crud.component';
import { NgxMaskDirective } from 'ngx-mask';
import { stages } from '../../location-reconstruction-of-exit.routes';
import {
  LocationReconstructionOfExitParcelsSectionTitlePipe
} from './pipes/location-reconstruction-of-exit-parcels-section-title.pipe';
import {
  LocationReconstructionOfExitParcels2SectionTitlePipe
} from './pipes/location-reconstruction-of-exit-parcels2-section-title.pipe';
import {
  ExposedMapControlComponent
} from '../../../../../../common/exposed-map/exposed-map-control/exposed-map-control.component';
import { RoadControlsSetComponent } from '../../../common/components/road-controls-set/road-controls-set.component';

@Component({
  selector: 'app-location-data-section',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SpinnerComponent,
    ValidationErrorsComponent,
    StagesComponent,
    ParcelsCrudComponent,
    NgxMaskDirective,
    LocationReconstructionOfExitParcelsSectionTitlePipe,
    LocationReconstructionOfExitParcels2SectionTitlePipe,
    ExposedMapControlComponent,
    RoadControlsSetComponent
  ],
  providers: [LocationDataForm],
  templateUrl: './location-data-section.component.html'
})
export class LocationDataSectionComponent implements OnInit, OnDestroy {

  public stages: string[] = stages;

  public applicationId: string | undefined = this.route.snapshot.params['appId'];

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  constructor(
    private store$: Store,
    private router: Router,
    private route: ActivatedRoute,
    public form: LocationDataForm
  ) {
  }

  public submitAndGoNext(): void {
    const currentApp = this.application();
    if (this.form.valid && currentApp) {
      this.store$.dispatch(updateParcels({
        currentApp,
        payload: this.form.toWriteModel(),
        parcels: this.form.parcelsValues,
        successFnc: (applicationId: string) => {
          this.router.navigate(
            ['../inwestor'],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.router.navigate(['../dane-wniosku'], { relativeTo: this.route });
  }

  public ngOnInit(): void {
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
